import { ControlValueAccessor } from "@angular/forms";

export abstract class BaseControlValueAccessor<T> implements ControlValueAccessor {
  value: T;
  disabled: boolean;


  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/no-unused-vars
  protected onChange = (value: T) => {};
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  protected onTouched = () => {};

  // This method is called by Angular when a value is written to the control
  writeValue(value: T): void {
    this.value = value;
  }

  // Register a callback function that Angular forms will call when the form control's value changes in the UI
  registerOnChange(fn: (value: T) => void): void {
    this.onChange = fn;
  }

  // Register a callback function that Angular forms will call when the control is touched
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Method to be called when the form control is disabled
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // Method to handle change from UI
  onModelChange(value: T): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }
}
